import React from "react";

export default function DeleteModal({ onConfirm, onCancel }) {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-4 rounded-lg shadow-lg">
        <p className="text-lg">Êtes-vous sûr(e) de vouloir supprimer ce moteur ?</p>
        <div className="flex justify-end mt-4 space-x-2">
          <button
            className="bg-loginBordure hover:bg-gray-300 text-white hover:text-loginBordure hover:font-bold px-4 py-2 rounded-md"
            onClick={onCancel}
          >
            Annuler
          </button>
          <button
            className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md"
            onClick={onConfirm}
          >
            Supprimer
          </button>
        </div>
      </div>
    </div>
  );
}